// A client-side copy of the GSM 03.38 alphabet from
// backend/utils/notifications/dltTemplate.js.
//
// Duplicated deliberately, and only for live feedback as an admin types a
// wording into the Templates screen: the server stays the authority — every
// saved template and every preview is measured there, and those numbers are
// what the screen displays. This exists so the "one rupee sign triples the
// cost" warning appears while the character is being typed rather than after a
// round trip, which is when it can still cheaply be changed.
//
// If the two ever disagree, the server is right.

const GSM_BASIC =
  '@£$¥èéùìòÇ\nØø\rÅå' +
  'Δ_ΦΓΛΩΠΨΣΘΞÆæßÉ' +
  ' !"#¤%&\'()*+,-./0123456789:;<=>?' +
  '¡ABCDEFGHIJKLMNOPQRSTUVWXYZÄÖÑÜ§' +
  '¿abcdefghijklmnopqrstuvwxyzäöñüà';

/** One character to a reader, two GSM septets on the wire. */
const GSM_EXTENDED = '^{}\\[~]|€';

const BASIC = new Set(GSM_BASIC.split(''));
const EXTENDED = new Set(GSM_EXTENDED.split(''));

/**
 * The characters in `text` that force the whole message out of the 160-per-
 * segment alphabet and into UCS-2's 70, de-duplicated and in the order they
 * first appear. Iterated by code point so an emoji is reported as itself
 * rather than as two halves of a surrogate pair.
 */
export function nonGsmCharacters(text: string): string[] {
  const seen = new Set<string>();
  for (const ch of text) {
    if (!BASIC.has(ch) && !EXTENDED.has(ch)) seen.add(ch);
  }
  return [...seen];
}
